import { createTheme } from '@material-ui/core/styles';
import { helveticaBold, typographStyles } from './theme-constants/typograhy-overrides';
import { tcsmColors } from './theme-constants/colors';


const tcsmTheme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 640,
            md: 768,
            lg: 1024,
            xl: 1920,
        },
    },
    spacing: factor => `${1 * factor}rem`, /// changes base padding from 8px to 1rem = 16px default. Instead of creating new padding maps we can now write --  padding: theme.spacing(3),
});

//// Spacing override


tcsmTheme.palette.error.main = tcsmColors.red;
tcsmTheme.palette.text.secondary = tcsmColors.blue;

tcsmTheme.props = {
    MuiLink: {
        color: 'textSecondary',
        underline: 'always',
    },
};



tcsmTheme.typography.h1 = typographStyles.h1;
tcsmTheme.typography.h2 = typographStyles.h2;
tcsmTheme.typography.h3 = typographStyles.h3;
tcsmTheme.typography.h4 = typographStyles.h4;
tcsmTheme.typography.h5 = typographStyles.h5;
tcsmTheme.typography.h6 = typographStyles.h6;

// Paragraph
tcsmTheme.typography.body1 = typographStyles.body1;
////Pagraph Large
tcsmTheme.typography.body2 = typographStyles.body2;
/// Caption
tcsmTheme.typography.caption = typographStyles.caption;
// Input label styling
tcsmTheme.typography.subtitle1 = typographStyles.subtitle1;

/// Button font-weight override

tcsmTheme.overrides.MuiButton = {
    root: {
        minWidth: '7rem',
    },
    label: {
        fontWeight: 700,
        fontFamily: '"Helvetica Neue LT W05_55 Roman", Arial, sans- serif',
    },
};


/// Input styles

tcsmTheme.props.MuiTextField = {
    variant: 'outlined',
};
tcsmTheme.props.MuiOutlinedInput = {
    notched: false,
};
tcsmTheme.overrides.MuiOutlinedInput = {
    notchedOutline: {
        border: `1px solid ${tcsmColors.greyFour}`,
    },
    input: {
        marginTop: '.25rem',
        padding: '.5rem',
        boxSizing: 'border-box',
        minHeight: '2.125rem', ///matching CPG styles
    },
    focused: {
        borderColor: tcsmColors.blue,

        '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: '1px !important',
        },
    },
};
tcsmTheme.props.MuiInputLabel = {
    shrink: false,
    disableAnimation: true,
    variant: 'standard',

};
tcsmTheme.overrides.MuiInputLabel = {
    formControl: {
        position: 'static',
        transform: 'none',
    },
    root: {
        '& span': {
            fontFamily: helveticaBold,
        },
    },
};
tcsmTheme.overrides.MuiSelect = {
    root: {
        paddingRight: `${tcsmTheme.spacing(2.5)} !important`, // Prevents select arrow from running into the text 
    },
};


tcsmTheme.overrides.MuiInputBase = {
    root: {
        borderRadius: '3px',
        padding: 0,
    },
    input: {
        padding: '.75rem',
    },
};

tcsmTheme.overrides.MuiRadio = {
    
    checked: {
        color: '#0F6FA8 !important',
    },
    root: {
        color: tcsmColors.black,
        paddingTop: '.5rem',
        paddingBottom: '.25rem',
        '&:hover': {
            backgroundColor: 'transparent !important',
        },
    },
};

tcsmTheme.overrides.MuiCheckbox = {
    checked: {
        color: '#0F6FA8 !important',
    },
    root: {
        color: 'black !important',
        //paddingTop: '.5rem',
        //paddingBottom: '.25rem',
        '&:hover': {
            backgroundColor: 'transparent !important',
        },
    },
};


// Updating and overriding all tooltips to match designs. 
tcsmTheme.overrides.MuiTooltip = {
    tooltip: {
        background: '#ffffff !important',
        color: tcsmColors.black,
        boxShadow: '0px 4px 8px rgba(48, 48, 48, 0.3)',
        ...typographStyles.caption,
    },
    arrow: {
        color: '#ffffff !important',
    },
};


tcsmTheme.props.MuiRadio = {
    disableRipple: true,
};

tcsmTheme.props.MuiCheckbox = {
    disableRipple: true,
};


tcsmTheme.props.MuiFormLabel = {
    focused: false,

};
tcsmTheme.overrides.MuiFormLabel = {
    root: {
        color: tcsmColors.black,
    },
};
tcsmTheme.overrides.MuiFormControlLabel = {
    label: typographStyles.inputLabel,
};
/// Breadcrumb overrides
tcsmTheme.overrides.MuiBreadcrumbs = {
    separator: {
        color: tcsmColors.greyTwo,
    },
};

export default tcsmTheme;